export const questionsDB = {
  general: {
    easy: [
      {
        id: 1,
        question: "What is the capital of France?",
        options: ["London", "Berlin", "Paris", "Madrid"],
        correct: 2
      },
      {
        id: 2,
        question: "How many continents are there?",
        options: ["5", "6", "7", "8"],
        correct: 2
      },
      {
        id: 3,
        question: "What is 2 + 2?",
        options: ["3", "4", "5", "6"],
        correct: 1
      },
      {
        id: 4,
        question: "Which planet is known as the Red Planet?",
        options: ["Venus", "Mars", "Jupiter", "Saturn"],
        correct: 1
      },
      {
        id: 5,
        question: "What is the largest ocean on Earth?",
        options: ["Atlantic", "Indian", "Arctic", "Pacific"],
        correct: 3
      }
    ],
    medium: [
      {
        id: 6,
        question: "Who painted the Mona Lisa?",
        options: ["Van Gogh", "Picasso", "Leonardo da Vinci", "Michelangelo"],
        correct: 2
      },
      {
        id: 7,
        question: "What is the chemical symbol for gold?",
        options: ["Go", "Gd", "Au", "Ag"],
        correct: 2
      },
      {
        id: 8,
        question: "In which year did World War II end?",
        options: ["1944", "1945", "1946", "1947"],
        correct: 1
      },
      {
        id: 9,
        question: "What is the smallest country in the world?",
        options: ["Monaco", "San Marino", "Vatican City", "Liechtenstein"],
        correct: 2
      },
      {
        id: 10,
        question: "Which element has the chemical symbol 'O'?",
        options: ["Osmium", "Oxygen", "Gold", "Silver"],
        correct: 1
      }
    ],
    hard: [
      {
        id: 11,
        question: "What is the speed of light in vacuum?",
        options: ["299,792,458 m/s", "300,000,000 m/s", "186,000 miles/s", "All of the above"],
        correct: 0
      },
      {
        id: 12,
        question: "Who developed the theory of general relativity?",
        options: ["Newton", "Einstein", "Hawking", "Planck"],
        correct: 1
      },
      {
        id: 13,
        question: "What is the most abundant gas in Earth's atmosphere?",
        options: ["Oxygen", "Nitrogen", "Carbon Dioxide", "Argon"],
        correct: 1
      },
      {
        id: 14,
        question: "In which year was the first computer bug found?",
        options: ["1945", "1947", "1950", "1952"],
        correct: 1
      },
      {
        id: 15,
        question: "What is the hardest natural substance on Earth?",
        options: ["Quartz", "Diamond", "Graphite", "Steel"],
        correct: 1
      }
    ]
  },
  science: {
    easy: [
      {
        id: 16,
        question: "How many bones are in the human body?",
        options: ["206", "208", "210", "212"],
        correct: 0
      },
      {
        id: 17,
        question: "What gas do plants absorb from the atmosphere?",
        options: ["Oxygen", "Nitrogen", "Carbon Dioxide", "Hydrogen"],
        correct: 2
      },
      {
        id: 18,
        question: "What is the center of an atom called?",
        options: ["Electron", "Proton", "Neutron", "Nucleus"],
        correct: 3
      },
      {
        id: 19,
        question: "How many chambers does a human heart have?",
        options: ["2", "3", "4", "5"],
        correct: 2
      },
      {
        id: 20,
        question: "What is the chemical formula for water?",
        options: ["H2O", "CO2", "NaCl", "O2"],
        correct: 0
      }
    ],
    medium: [
      {
        id: 21,
        question: "What is the powerhouse of the cell?",
        options: ["Nucleus", "Mitochondria", "Ribosome", "Cytoplasm"],
        correct: 1
      },
      {
        id: 22,
        question: "What type of blood vessels carry blood away from the heart?",
        options: ["Veins", "Arteries", "Capillaries", "Venules"],
        correct: 1
      },
      {
        id: 23,
        question: "What is the study of earthquakes called?",
        options: ["Geology", "Seismology", "Meteorology", "Volcanology"],
        correct: 1
      },
      {
        id: 24,
        question: "Which organ produces insulin?",
        options: ["Liver", "Kidney", "Pancreas", "Stomach"],
        correct: 2
      },
      {
        id: 25,
        question: "What is the most abundant element in the universe?",
        options: ["Oxygen", "Carbon", "Hydrogen", "Helium"],
        correct: 2
      }
    ],
    hard: [
      {
        id: 26,
        question: "What is the half-life of Carbon-14?",
        options: ["5,730 years", "4,500 years", "6,200 years", "5,200 years"],
        correct: 0
      },
      {
        id: 27,
        question: "Which particle is responsible for the weak nuclear force?",
        options: ["Photon", "Gluon", "W and Z bosons", "Higgs boson"],
        correct: 2
      },
      {
        id: 28,
        question: "What is the Chandrasekhar limit?",
        options: ["1.4 solar masses", "2.4 solar masses", "3.4 solar masses", "0.4 solar masses"],
        correct: 0
      },
      {
        id: 29,
        question: "Which enzyme breaks down proteins in the stomach?",
        options: ["Amylase", "Lipase", "Pepsin", "Trypsin"],
        correct: 2
      },
      {
        id: 30,
        question: "What is the fundamental principle behind MRI?",
        options: ["X-ray absorption", "Nuclear magnetic resonance", "Ultrasound waves", "Gamma radiation"],
        correct: 1
      }
    ]
  },
  history: {
    easy: [
      {
        id: 31,
        question: "Who was the first President of the United States?",
        options: ["Thomas Jefferson", "George Washington", "John Adams", "Benjamin Franklin"],
        correct: 1
      },
      {
        id: 32,
        question: "In which year did the Titanic sink?",
        options: ["1912", "1913", "1914", "1915"],
        correct: 0
      },
      {
        id: 33,
        question: "Which ancient wonder of the world was located in Egypt?",
        options: ["Hanging Gardens", "Colossus of Rhodes", "Great Pyramid of Giza", "Lighthouse of Alexandria"],
        correct: 2
      },
      {
        id: 34,
        question: "Who wrote 'Romeo and Juliet'?",
        options: ["Charles Dickens", "William Shakespeare", "Jane Austen", "Mark Twain"],
        correct: 1
      },
      {
        id: 35,
        question: "Which empire was ruled by Julius Caesar?",
        options: ["Greek Empire", "Roman Empire", "Persian Empire", "Egyptian Empire"],
        correct: 1
      }
    ],
    medium: [
      {
        id: 36,
        question: "The Berlin Wall fell in which year?",
        options: ["1987", "1988", "1989", "1990"],
        correct: 2
      },
      {
        id: 37,
        question: "Who was the first person to walk on the moon?",
        options: ["Buzz Aldrin", "Neil Armstrong", "John Glenn", "Alan Shepard"],
        correct: 1
      },
      {
        id: 38,
        question: "Which war was fought between 1914 and 1918?",
        options: ["World War II", "Vietnam War", "World War I", "Korean War"],
        correct: 2
      },
      {
        id: 39,
        question: "Who invented the printing press?",
        options: ["Leonardo da Vinci", "Johannes Gutenberg", "Thomas Edison", "Alexander Graham Bell"],
        correct: 1
      },
      {
        id: 40,
        question: "The Renaissance began in which country?",
        options: ["France", "Germany", "Italy", "Spain"],
        correct: 2
      }
    ],
    hard: [
      {
        id: 41,
        question: "The Treaty of Westphalia was signed in which year?",
        options: ["1648", "1658", "1668", "1678"],
        correct: 0
      },
      {
        id: 42,
        question: "Who was the last Tsar of Russia?",
        options: ["Alexander III", "Nicholas II", "Alexander II", "Nicholas I"],
        correct: 1
      },
      {
        id: 43,
        question: "The Peloponnesian War was fought between which two city-states?",
        options: ["Athens and Sparta", "Rome and Carthage", "Athens and Thebes", "Sparta and Corinth"],
        correct: 0
      },
      {
        id: 44,
        question: "Which emperor built the Colosseum in Rome?",
        options: ["Julius Caesar", "Augustus", "Vespasian", "Nero"],
        correct: 2
      },
      {
        id: 45,
        question: "The Congress of Vienna took place in which year?",
        options: ["1814-1815", "1815-1816", "1813-1814", "1816-1817"],
        correct: 0
      }
    ]
  },
  technology: {
    easy: [
      {
        id: 46,
        question: "What does 'WWW' stand for?",
        options: ["World Wide Web", "World Wide Website", "Web World Wide", "Website World Wide"],
        correct: 0
      },
      {
        id: 47,
        question: "Which company created the iPhone?",
        options: ["Google", "Microsoft", "Apple", "Samsung"],
        correct: 2
      },
      {
        id: 48,
        question: "What does 'USB' stand for?",
        options: ["Universal Serial Bus", "Universal System Bus", "United Serial Bus", "United System Bus"],
        correct: 0
      },
      {
        id: 49,
        question: "Which programming language is known for web development?",
        options: ["Python", "JavaScript", "C++", "Java"],
        correct: 1
      },
      {
        id: 50,
        question: "What is the most popular operating system for mobile devices?",
        options: ["iOS", "Windows", "Android", "Linux"],
        correct: 2
      }
    ],
    medium: [
      {
        id: 51,
        question: "What does 'AI' stand for in technology?",
        options: ["Automated Intelligence", "Artificial Intelligence", "Advanced Intelligence", "Applied Intelligence"],
        correct: 1
      },
      {
        id: 52,
        question: "Which company developed React.js?",
        options: ["Google", "Facebook", "Microsoft", "Apple"],
        correct: 1
      },
      {
        id: 53,
        question: "What is the latest version of JavaScript as of 2023?",
        options: ["ES6", "ES2020", "ES2023", "ES2022"],
        correct: 2
      },
      {
        id: 54,
        question: "What does 'API' stand for?",
        options: ["Application Programming Interface", "Advanced Programming Interface", "Application Program Interface", "Advanced Program Interface"],
        correct: 0
      },
      {
        id: 55,
        question: "Which database is known as a NoSQL database?",
        options: ["MySQL", "PostgreSQL", "MongoDB", "SQLite"],
        correct: 2
      }
    ],
    hard: [
      {
        id: 56,
        question: "What is the time complexity of QuickSort in the average case?",
        options: ["O(n)", "O(n log n)", "O(n²)", "O(log n)"],
        correct: 1
      },
      {
        id: 57,
        question: "Which design pattern is used in React for state management?",
        options: ["Observer", "Singleton", "Flux", "Factory"],
        correct: 2
      },
      {
        id: 58,
        question: "What is the purpose of Docker in software development?",
        options: ["Code editing", "Containerization", "Database management", "Web hosting"],
        correct: 1
      },
      {
        id: 59,
        question: "Which protocol is used for secure web communication?",
        options: ["HTTP", "HTTPS", "FTP", "SMTP"],
        correct: 1
      },
      {
        id: 60,
        question: "What is the main difference between REST and GraphQL?",
        options: ["REST is faster", "GraphQL allows querying specific fields", "REST is newer", "GraphQL is only for databases"],
        correct: 1
      }
    ]
  },
  geography: {
    easy: [
      {
        id: 61,
        question: "What is the capital of Australia?",
        options: ["Sydney", "Melbourne", "Canberra", "Perth"],
        correct: 2
      },
      {
        id: 62,
        question: "Which is the longest river in the world?",
        options: ["Amazon", "Nile", "Mississippi", "Yangtze"],
        correct: 1
      },
      {
        id: 63,
        question: "How many continents are there?",
        options: ["5", "6", "7", "8"],
        correct: 2
      },
      {
        id: 64,
        question: "Which country has the most time zones?",
        options: ["Russia", "USA", "China", "Canada"],
        correct: 0
      },
      {
        id: 65,
        question: "What is the smallest country in the world?",
        options: ["Monaco", "Vatican City", "San Marino", "Liechtenstein"],
        correct: 1
      }
    ],
    medium: [
      {
        id: 66,
        question: "Which mountain range contains Mount Everest?",
        options: ["Andes", "Alps", "Himalayas", "Rockies"],
        correct: 2
      },
      {
        id: 67,
        question: "What is the capital of Canada?",
        options: ["Toronto", "Vancouver", "Montreal", "Ottawa"],
        correct: 3
      },
      {
        id: 68,
        question: "Which desert is the largest in the world?",
        options: ["Sahara", "Gobi", "Antarctic", "Arabian"],
        correct: 2
      },
      {
        id: 69,
        question: "Which country is both in Europe and Asia?",
        options: ["Russia", "Turkey", "Kazakhstan", "All of the above"],
        correct: 3
      },
      {
        id: 70,
        question: "What is the deepest ocean trench?",
        options: ["Puerto Rico Trench", "Java Trench", "Mariana Trench", "Peru-Chile Trench"],
        correct: 2
      }
    ],
    hard: [
      {
        id: 71,
        question: "Which country has the most natural lakes?",
        options: ["Finland", "Canada", "Sweden", "Russia"],
        correct: 1
      },
      {
        id: 72,
        question: "What is the highest waterfall in the world?",
        options: ["Niagara Falls", "Victoria Falls", "Angel Falls", "Iguazu Falls"],
        correct: 2
      },
      {
        id: 73,
        question: "Which strait separates Europe and Africa?",
        options: ["Strait of Gibraltar", "Bosphorus", "Dardanelles", "Strait of Hormuz"],
        correct: 0
      },
      {
        id: 74,
        question: "What is the most volcanically active region on Earth?",
        options: ["Mediterranean", "Ring of Fire", "Mid-Atlantic Ridge", "East African Rift"],
        correct: 1
      },
      {
        id: 75,
        question: "Which city is located on two continents?",
        options: ["Cairo", "Istanbul", "Suez", "Casablanca"],
        correct: 1
      }
    ]
  },
  sports: {
    easy: [
      {
        id: 76,
        question: "How many players are on a basketball team on the court?",
        options: ["4", "5", "6", "7"],
        correct: 1
      },
      {
        id: 77,
        question: "In which sport do you use a racket?",
        options: ["Basketball", "Football", "Tennis", "Swimming"],
        correct: 2
      },
      {
        id: 78,
        question: "How often are the Olympic Games held?",
        options: ["Every 2 years", "Every 3 years", "Every 4 years", "Every 5 years"],
        correct: 2
      },
      {
        id: 79,
        question: "What is the maximum score in ten-pin bowling?",
        options: ["200", "250", "300", "350"],
        correct: 2
      },
      {
        id: 80,
        question: "Which sport is known as 'The Beautiful Game'?",
        options: ["Basketball", "Football/Soccer", "Tennis", "Baseball"],
        correct: 1
      }
    ],
    medium: [
      {
        id: 81,
        question: "Who has won the most Grand Slam tennis titles?",
        options: ["Roger Federer", "Rafael Nadal", "Novak Djokovic", "Serena Williams"],
        correct: 2
      },
      {
        id: 82,
        question: "In which year was the first FIFA World Cup held?",
        options: ["1928", "1930", "1932", "1934"],
        correct: 1
      },
      {
        id: 83,
        question: "What is the diameter of a basketball hoop?",
        options: ["16 inches", "18 inches", "20 inches", "22 inches"],
        correct: 1
      },
      {
        id: 84,
        question: "Which country has won the most World Cup titles?",
        options: ["Germany", "Argentina", "Brazil", "Italy"],
        correct: 2
      },
      {
        id: 85,
        question: "What is the fastest recorded tennis serve?",
        options: ["253 km/h", "263 km/h", "273 km/h", "283 km/h"],
        correct: 1
      }
    ],
    hard: [
      {
        id: 86,
        question: "Who holds the record for most home runs in a single MLB season?",
        options: ["Babe Ruth", "Barry Bonds", "Mark McGwire", "Sammy Sosa"],
        correct: 1
      },
      {
        id: 87,
        question: "In Formula 1, what does DRS stand for?",
        options: ["Drag Reduction System", "Direct Racing System", "Dynamic Racing System", "Drive Reduction System"],
        correct: 0
      },
      {
        id: 88,
        question: "Which golfer has won the most major championships?",
        options: ["Tiger Woods", "Jack Nicklaus", "Arnold Palmer", "Gary Player"],
        correct: 1
      },
      {
        id: 89,
        question: "What is the maximum break in snooker?",
        options: ["147", "155", "167", "180"],
        correct: 0
      },
      {
        id: 90,
        question: "Which swimmer has won the most Olympic gold medals?",
        options: ["Mark Spitz", "Michael Phelps", "Katie Ledecky", "Ryan Lochte"],
        correct: 1
      }
    ]
  },
  entertainment: {
    easy: [
      {
        id: 91,
        question: "Who directed the movie 'Titanic'?",
        options: ["Steven Spielberg", "James Cameron", "Christopher Nolan", "Ridley Scott"],
        correct: 1
      },
      {
        id: 92,
        question: "Which Disney movie features the song 'Let It Go'?",
        options: ["Moana", "Frozen", "Tangled", "Encanto"],
        correct: 1
      },
      {
        id: 93,
        question: "What is the highest-grossing film of all time?",
        options: ["Titanic", "Avatar", "Avengers: Endgame", "Star Wars: The Force Awakens"],
        correct: 2
      },
      {
        id: 94,
        question: "Which TV series features dragons and the Iron Throne?",
        options: ["Vikings", "The Witcher", "Game of Thrones", "House of the Dragon"],
        correct: 2
      },
      {
        id: 95,
        question: "Who played Harry Potter in the film series?",
        options: ["Tom Holland", "Daniel Radcliffe", "Rupert Grint", "Eddie Redmayne"],
        correct: 1
      }
    ],
    medium: [
      {
        id: 96,
        question: "Which film won the Academy Award for Best Picture in 2020?",
        options: ["1917", "Joker", "Parasite", "Once Upon a Time in Hollywood"],
        correct: 2
      },
      {
        id: 97,
        question: "Who composed the music for 'Star Wars'?",
        options: ["Hans Zimmer", "John Williams", "Danny Elfman", "Howard Shore"],
        correct: 1
      },
      {
        id: 98,
        question: "In which year was Netflix founded?",
        options: ["1995", "1997", "1999", "2001"],
        correct: 1
      },
      {
        id: 99,
        question: "Which actor played the Joker in 'The Dark Knight'?",
        options: ["Joaquin Phoenix", "Jack Nicholson", "Heath Ledger", "Jared Leto"],
        correct: 2
      },
      {
        id: 100,
        question: "What is the longest-running animated TV series?",
        options: ["The Simpsons", "South Park", "Family Guy", "SpongeBob SquarePants"],
        correct: 0
      }
    ],
    hard: [
      {
        id: 101,
        question: "Which director has won the most Academy Awards for Best Director?",
        options: ["Steven Spielberg", "Martin Scorsese", "John Ford", "Frank Capra"],
        correct: 2
      },
      {
        id: 102,
        question: "What is the first rule of Fight Club?",
        options: ["Be prepared to fight", "You do not talk about Fight Club", "Fight fair", "No weapons allowed"],
        correct: 1
      },
      {
        id: 103,
        question: "Which film holds the record for most Academy Award nominations?",
        options: ["Titanic", "All About Eve", "La La Land", "Lord of the Rings: The Fellowship of the Ring"],
        correct: 1
      },
      {
        id: 104,
        question: "Who wrote the novel that 'Blade Runner' is based on?",
        options: ["Isaac Asimov", "Philip K. Dick", "Arthur C. Clarke", "Ray Bradbury"],
        correct: 1
      },
      {
        id: 105,
        question: "Which streaming service produced 'Stranger Things'?",
        options: ["Amazon Prime", "Hulu", "Netflix", "Disney+"],
        correct: 2
      }
    ]
  },
  literature: {
    easy: [
      {
        id: 106,
        question: "Who wrote 'Romeo and Juliet'?",
        options: ["Charles Dickens", "William Shakespeare", "Jane Austen", "Mark Twain"],
        correct: 1
      },
      {
        id: 107,
        question: "Which book begins with 'It was the best of times, it was the worst of times'?",
        options: ["Great Expectations", "A Tale of Two Cities", "Oliver Twist", "David Copperfield"],
        correct: 1
      },
      {
        id: 108,
        question: "Who wrote 'To Kill a Mockingbird'?",
        options: ["Harper Lee", "Toni Morrison", "Maya Angelou", "Zora Neale Hurston"],
        correct: 0
      },
      {
        id: 109,
        question: "In which city is Shakespeare's 'Romeo and Juliet' set?",
        options: ["Venice", "Florence", "Verona", "Rome"],
        correct: 2
      },
      {
        id: 110,
        question: "Who wrote the 'Harry Potter' series?",
        options: ["J.R.R. Tolkien", "C.S. Lewis", "J.K. Rowling", "Roald Dahl"],
        correct: 2
      }
    ],
    medium: [
      {
        id: 111,
        question: "Which novel features the character Atticus Finch?",
        options: ["Of Mice and Men", "To Kill a Mockingbird", "The Great Gatsby", "Catcher in the Rye"],
        correct: 1
      },
      {
        id: 112,
        question: "Who wrote '1984'?",
        options: ["Aldous Huxley", "Ray Bradbury", "George Orwell", "Kurt Vonnegut"],
        correct: 2
      },
      {
        id: 113,
        question: "What is the first book in 'The Chronicles of Narnia' series?",
        options: ["The Lion, the Witch and the Wardrobe", "Prince Caspian", "The Magician's Nephew", "The Horse and His Boy"],
        correct: 0
      },
      {
        id: 114,
        question: "Who wrote 'Pride and Prejudice'?",
        options: ["Charlotte Brontë", "Emily Brontë", "Jane Austen", "George Eliot"],
        correct: 2
      },
      {
        id: 115,
        question: "Which Shakespearean play features the characters Iago and Desdemona?",
        options: ["Hamlet", "Macbeth", "Othello", "King Lear"],
        correct: 2
      }
    ],
    hard: [
      {
        id: 116,
        question: "Who wrote 'One Hundred Years of Solitude'?",
        options: ["Gabriel García Márquez", "Mario Vargas Llosa", "Jorge Luis Borges", "Pablo Neruda"],
        correct: 0
      },
      {
        id: 117,
        question: "Which novel won the Pulitzer Prize for Fiction in 2021?",
        options: ["The Vanishing Half", "Hamnet", "The Midnight Library", "The Power"],
        correct: 0
      },
      {
        id: 118,
        question: "Who wrote 'Invisible Man'?",
        options: ["James Baldwin", "Ralph Ellison", "Richard Wright", "Langston Hughes"],
        correct: 1
      },
      {
        id: 119,
        question: "Which poet wrote 'The Waste Land'?",
        options: ["W.H. Auden", "T.S. Eliot", "Ezra Pound", "Robert Frost"],
        correct: 1
      },
      {
        id: 120,
        question: "What is the opening line of 'Anna Karenina'?",
        options: ["It was the best of times", "All happy families are alike", "Call me Ishmael", "In a hole in the ground there lived a hobbit"],
        correct: 1
      }
    ]
  }
};

export const categories = [
  { value: 'general', label: 'General Knowledge' },
  { value: 'science', label: 'Science' },
  { value: 'history', label: 'History' },
  { value: 'technology', label: 'Technology' },
  { value: 'geography', label: 'Geography' },
  { value: 'sports', label: 'Sports' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'literature', label: 'Literature' }
];

export const difficulties = [
  { value: 'easy', label: 'Easy' },
  { value: 'medium', label: 'Medium' },
  { value: 'hard', label: 'Hard' }
];

export const getQuestions = (category, difficulty, count = 5) => {
  const questions = questionsDB[category]?.[difficulty] || [];
  // Shuffle and return specified number of questions
  const shuffled = [...questions].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

